import client from './client'

export default class UserService {
  me () {
    return client.get('/api/user/me')
  }

  login (email, password) {
    return client.post('/api/user/login', {
      email: email,
      password: password,
    })
  }

  logOut () {
    return client.get('/api/user/logout')
  }

  list (params) {
    return client.get('/api/user/list', params)
  }

  update (id, group) {
    return client.post('/api/user/' + id + '/update', {
      group: group,
    })
  }
}
